<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__rdaccountdailystat}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <!-- <el-form-item>
            <el-input v-model="dataForm.advertiserId" placeholder="广告主账号" clearable></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-select style="width:150px;margin-right: 1px;" v-model="dataForm.dateText" filterable clearable placeholder="日期范围">
                  <el-option
                          v-for="item in dateList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
            <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="getList()">{{ $t('query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item> -->
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
  <!--        </el-form-item>-->
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
  <!--        </el-form-item>-->
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
          <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
          <el-table-column prop="statDatetime" label="日期" header-align="center" align="center"></el-table-column>
  
          <el-table-column prop="advertiserId" label="账户id" header-align="center" align="center"></el-table-column>
          <el-table-column prop="media" label="媒体" header-align="center" align="center"></el-table-column>
          <el-table-column prop="city" label="城市" header-align="center" align="center"></el-table-column>
         
          <el-table-column prop="cost" label="消耗" header-align="center" align="center"></el-table-column>
          <el-table-column prop="show" label="展示数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="click" label="点击数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="ctr" label="点击率(%)" header-align="center" align="center"></el-table-column>
          <el-table-column prop="avgClickCost" label="平均点击单价(元)" header-align="center" align="center"></el-table-column>
          <el-table-column prop="avgShowCost" label="平均千次展现费用(元)" header-align="center" align="center"></el-table-column>
          <el-table-column prop="convert" label="浅转数" header-align="center" align="center"></el-table-column>
          <el-table-column prop="convertCost" label="转化成本" header-align="center" align="center"></el-table-column>
          <el-table-column prop="convertRate" label="转化率(%)" header-align="center" align="center"></el-table-column>
         <el-table-column prop="deepConvert" label="深转数" header-align="center" align="center"></el-table-column>
         <el-table-column prop="deepConvertCost" label="深度转化成本" header-align="center" align="center"></el-table-column>
         <el-table-column prop="deepConvertRate" label="深度转化率(%)" header-align="center" align="center"></el-table-column>
  
        </el-table>
        
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <div>
          
          <echarts ref="echarts"></echarts>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
       
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './advertising-add-or-update'
  import echarts from '../../../components/echarts.vue'
  import {getReport}  from '../../../api/list'
  export default {
    mixins: [mixinViewModule],
    mounted(){
      // this.report()
    
    },
    data () {

      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/report/adverPage',
          getDataListIsPage: true,
          exportURL: '/by/advertising/export',
          deleteURL: '/by/advertising/',
          reportURL:'/sys/report/adverTotal',
          deleteIsBatch: true
        },
        dateList:[
            {
                label: '分日',
                value: '0',
            },
            {
                label: '分周',
                value: '1',
            },
            {
                label: '合计',
                value: '2',
            },
        ],
        date:'',
        dataForm: {
          id: '',
          advertiserId:'',
          start:'',
          dateText:'',
          end:''
        }
      }
    },
    watch:{
      dataList(n,o){
        
        this.report()
      }
    },
    components: {
      AddOrUpdate,
      echarts
    },
    methods: {
      report(){
        getReport({end:this.dataForm.end, start:this.dataForm.start}).then(r => {
        console.log(r.data)
        let obj = r.data.data
        this.$refs.echarts.init([
                                { value: obj.cost,name:`消耗${obj.cost}`  },
                                { value: obj.show, name: `展示数${obj.show}` },
                                { value: obj.click , name: `点击数${obj.click}`  },
                                { value: obj.ctr, name: `点击率${obj.ctr }`  },
                                { value: obj.avgClickCost, name: `平均点击单价${obj.avgClickCost}元` },
                                { value: obj.avgShowCost, name: `平均千次展现费用${obj.avgShowCost}元` },
                                { value: obj.convert, name: `浅转数${obj.convert}` },
                                { value: obj.convertCost , name: `转化成本${obj.convertCost}` },
                                { value: obj.convertRate, name: `转化率${obj.convertRate}%` },
                                { value: obj.deepConvert, name: `深转数${obj.deepConvert}` },
                                { value: obj.deepConvertCost, name: `深度转化成本${obj.deepConvertCost}` },
                                { value: obj.deepConvertRate, name: `深度转化率${obj.deepConvertRate}%` },
        ])
      })
      
      },
      //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
      //⽀付时间戳设置
      getTimes() {
        if (this.date != null) {
          this.dataForm.start = this.date[0]
          this.dataForm.end = this.date[1]
        }else{
          this.dataForm.startDate =''
          this.dataForm.endDate = ''
        }
      },
      getList(){
        if(!this.dataForm.dateText){
            this.dataForm.dateText = '分日'
        }
        if(!this.dataForm.start || !this.dataForm.end){
            this.$message({
                message: '请选择日期在查询',
                type:'warning'
            })
            return
        }
        this.getDataList()
      
      }
    }
  }
  </script>
  